import { DISABLED, ENABLED } from 'app/constants';

export const formatBooleanForDetailsPage = (v?: boolean) => (v ? ENABLED : DISABLED);
